




















import { mapGetters } from 'vuex';
import { getAutoclickerGames } from '@/api/CopyStake/AutoClicker';
import { TAutoclickerGameData } from '@/api/schema';
import { TAiStreamer } from '@/views/CopyStake/CopyStakeAutoclicker/types';

type TWebAiStreamersTabState = {
  showEditModal: boolean;
  selectedItem: TAiStreamer;
  supportedGames: TAutoclickerGameData[];
  loading: Record<string, boolean>;
};

const CopyStakeAiStreamerEditModal = (): Promise<any> =>
  import(
    '@/views/CopyStake/CopyStakeAutoclicker/AiStreamers/CopyStakeAiStreamerEditModal.vue'
  );

export default {
  name: 'CopyStakeAiStreamersTab',
  components: {
    CopyStakeAiStreamerEditModal
  },
  props: {
    active: {
      type: Boolean,
      default: false
    }
  },
  data(): TWebAiStreamersTabState {
    return {
      showEditModal: false,
      selectedItem: undefined,
      supportedGames: [],
      loading: {
        games: false
      }
    };
  },
  watch: {
    active: {
      handler(active: boolean): void {
        if (active) {
          this.getSupportedGames();
        }
      },
      immediate: false
    },
    operatorId: {
      handler(): void {
        if (this.operatorId !== null) {
          this.getSupportedGames();
        }
      },
      immediate: true
    },
    showEditModal(val: boolean): void {
      if (!val) {
        this.resetSelectedItem();
      }
    }
  },
  computed: {
    ...mapGetters('Onboarding', ['operatorId']),
    isLoading(): boolean {
      return Object.values(this.loading).some(Boolean);
    }
  },
  methods: {
    openEditModal(): void {
      this.showEditModal = true;
    },

    async getSupportedGames(): Promise<void> {
      this.loading.games = true;

      getAutoclickerGames()
        .then((data) => {
          this.supportedGames = data;
        })
        .catch(() => {
          this.supportedGames = [];
        })
        .finally(() => {
          this.loading.games = false;
        });
    },
    resetSelectedItem(): void {
      this.selectedItem = undefined;
    }
  }
};
